export default __webpack_public_path__ + "static/media/sonia.8e64d66a.jpg";